import {
    faCalendarCheck,
    faWallet,
    faCircleCheck,
    faMobileScreenButton,
    faTriangleExclamation,
    faBan,
    faVideo,
} from '@fortawesome/free-solid-svg-icons';

/**
 * Nội dung ĐIỀU KHOẢN HOÀN TIỀN, tách riêng khỏi phần hiển thị (Policy.js).
 *
 * Cấu trúc:
 * - platformTimeline: bảng thời gian ghi nhận/rút tiền theo từng sàn
 * - timelineRows / accept / reject: các dòng bản rút gọn
 * - expandedAccept / expandedReject: các dòng bản chi tiết ("XEM THÊM")
 * - fraudList + closingNote: phần cuối bản chi tiết
 *
 * Mỗi sàn có thể dùng DEFAULT_POLICY hoặc một bản riêng (vd SHOPEEFOOD_POLICY).
 */

const FRAUD_LIST = [
    'Hủy đơn, boom hàng hoặc treo đơn không thanh toán bị hủy nhiều lần.',
    'Mua nhiều đơn hàng, mặt hàng giống nhau.',
    'Sử dụng nhiều tài khoản trên cùng 1 thiết bị. Sử dụng nhiều thiết bị chung thông tin nhận hàng (bao gồm wifi, email, số điện thoại, khu vực nhận hàng).',
    'Sử dụng nhiều mã giảm giá giống nhau, trùng lặp trong một khoảng thời gian nhất định.',
    'Click nhiều link từ nhiều KOL, group khác nhau để mua hàng.',
];

const CLOSING_NOTE =
    'Và còn rất nhiều lý do khác... Lưu ý, các thông tin phía trên là team Longhousee tự tổng hợp. Đối tác không cung cấp lý do cụ thể hủy đơn hoặc không ghi nhận đơn của người dùng.';

// Dòng "Sau 24H - 48H..." + "Đủ 10.000đ số dư..." dùng chung cho mọi sàn
const TIMELINE_UPDATE_TEXT =
    'Sau 24H - 48H kể từ khi đặt hàng và thanh toán thành công, đơn hàng sẽ được cập nhật lên website/app. Nếu quá 48H đơn hàng không hiển thị tức là đơn hàng không được ghi nhận.';

const TIMELINE_WITHDRAW_ROW = {
    icon: faWallet,
    text: 'Đủ 10.000đ số dư hoàn tiền, bạn có thể rút tiền về tài khoản ngân hàng và nhận tiền sau 2 – 7 ngày khi bạn thực hiện lệnh rút.',
};

// Dòng đầu tiên của "Từ chối hoàn tiền" bản chi tiết, dùng chung cho mọi sàn
const COMMON_EXPANDED_REJECT_FIRST = {
    icon: faBan,
    iconClass: 'text-red-600',
    text: 'Đơn hàng không được cập nhật, không hợp lệ hoặc bị hủy do đối tác nghi ngờ gian lận. Kết quả hoàn tiền phụ thuộc vào quyết định sau cùng của đối tác. Website/app chỉ đảm nhận vai trò lấy dữ liệu đơn từ sàn cung cấp.',
};

export const DEFAULT_POLICY = {
    platformTimeline: [
        { platform: 'Shopee', description: 'Dán link -> Ghi nhận sau 24h – 48h -> Có thể rút tiền sau 7 – 30 ngày' },
        { platform: 'Tiktok', description: 'Dán link -> Ghi nhận ngay sau khi mua -> Có thể rút tiền sau 7 ngày' },
        { platform: 'Lazada', description: 'Dán link -> Ghi nhận sau 24h – 48h -> Có thể rút tiền sau 30 – 45 ngày' },
    ],
    timelineRows: [
        {
            icon: faCalendarCheck,
            text: `${TIMELINE_UPDATE_TEXT} Bạn có thể kiểm tra đơn hàng hợp lệ`,
            link: { to: '/user-info/order', label: 'tại đây' },
        },
        TIMELINE_WITHDRAW_ROW,
    ],
    accept: [
        { icon: faCircleCheck, text: 'Là đơn hàng được Shopee/Lazada/Tiktok (gọi chung là đối tác) xét duyệt hợp lệ và đủ điều kiện nhận hoàn tiền.' },
        { icon: faMobileScreenButton, text: 'Là đơn hàng phát sinh trên điện thoại và thao tác đúng các bước hướng dẫn tại website/app.' },
        { icon: faWallet, text: 'Số tiền hoàn được tính dự trên phần trăm hoa hồng mà đối tác trả cho website/app.' },
    ],
    reject: [
        { icon: faBan, text: 'Đơn hàng vi phạm chính sách của đối tác dẫn tới không ghi nhận tại website/app.' },
        { icon: faTriangleExclamation, text: 'Đơn hàng có dấu hiệu gian lận mã giảm giá, tích trữ hàng hóa…' },
        { icon: faVideo, text: 'Đơn hàng phát sinh từ Live/Video/Youtube của Shop/KOL/KOC.' },
    ],
    expandedAccept: [
        'Là đơn hàng được đối tác xét duyệt hợp lệ và đủ điều kiện hoàn tiền. Lưu ý, tuân thủ các Điều kiện & Điều khoản của website/app là để tăng khả năng duyệt hoàn tiền. Kết quả sau cùng được duyệt/hủy hoàn tiền hoàn toàn thuộc quyết định của đối tác.',
        'Là đơn hàng phát sinh trên điện thoại, thao tác đúng các bước tại website/app và trong vòng 30 phút trước đó không click, nhấn link mở đối tác của bất kì KOL/group/Fanpage nào khác (bao gồm cả xem giỏ live/video).',
        'Số tiền hoàn được tính dựa trên phần trăm hoa hồng từ sàn + phần trăm hoa hồng từ shop trả cho website/app. Vì thế số tiền hoàn sẽ không cố định hoặc có thể thấp hơn dự kiến do bạn áp xu hoặc mã giảm giá...',
        'Bấm Mua ngay sau đó thêm sản phẩm vào giỏ hàng để canh sale hoặc áp mã giảm giá vẫn được tính hoàn tiền. Khuyến khích thanh toán cod/spp/banking... Không khuyến khích thanh toán bằng SpayLater.',
        'Trường hợp mua nhiều sản phẩm cùng 1 Shop, bạn chỉ cần dán link 1 món. Mua nhiều sản phẩm từ nhiều Shop bạn nên kiểm tra sản phẩm nào được hoàn tiền cao nhất thì bấm thêm giỏ sau cùng và mua hàng, tuy nhiên số tiền hoàn sẽ không tối đa (áp dụng cho Shopee).',
    ],
    expandedReject: [
        COMMON_EXPANDED_REJECT_FIRST,
        {
            icon: faTriangleExclamation,
            iconClass: 'text-yellow-600',
            text: 'Đơn hàng phát sinh tại Live/ Video/ Youtube của Shop/KOL/KOC (bao gồm việc thêm giỏ hàng, xem giỏ hàng, chốt đơn từ các phiên live/video/youtube...) đều không được hoàn tiền. Trừ một số trường hợp đặc biệt, xem',
            href: '/post/videolist',
            linkLabel: 'tại đây',
        },
    ],
    fraudList: FRAUD_LIST,
    closingNote: CLOSING_NOTE,
};

/** Điều khoản riêng cho ShopeeFood (đặt món, không có Live/Video của Shop/KOL). */
export const SHOPEEFOOD_POLICY = {
    platformTimeline: [
        { platform: 'ShopeeFood', description: 'Dán link -> Ghi nhận sau 24h – 48h -> Có thể rút tiền sau 7 – 30 ngày' },
    ],
    // ShopeeFood không có link "kiểm tra đơn hàng hợp lệ" ở cuối dòng này
    timelineRows: [
        { icon: faCalendarCheck, text: TIMELINE_UPDATE_TEXT },
        TIMELINE_WITHDRAW_ROW,
    ],
    accept: [
        { icon: faCircleCheck, text: 'Là đơn hàng được ShopeeFood (gọi chung là đối tác) xét duyệt hợp lệ và đủ điều kiện nhận hoàn tiền.' },
        { icon: faMobileScreenButton, text: 'Là đơn hàng phát sinh tại app ShopeeFood và thao tác đúng các bước hướng dẫn tại website/app.' },
        { icon: faWallet, text: 'Số tiền hoàn được tính dự trên phần trăm hoa hồng mà đối tác trả cho website/app.' },
    ],
    reject: [
        { icon: faBan, text: 'Đơn hàng vi phạm chính sách của đối tác dẫn tới không ghi nhận tại website/app.' },
        { icon: faTriangleExclamation, text: 'Đơn hàng có dấu hiệu gian lận mã giảm giá, tích trữ hàng hóa…' },
    ],
    expandedAccept: [
        'Là đơn hàng được đối tác xét duyệt hợp lệ và đủ điều kiện hoàn tiền. Lưu ý, tuân thủ các Điều kiện & Điều khoản của website/app là để tăng khả năng duyệt hoàn tiền. Kết quả sau cùng được duyệt/hủy hoàn tiền hoàn toàn thuộc quyết định của đối tác.',
        'Là đơn hàng phát sinh trên điện thoại, thao tác đúng các bước tại website/app. Gắn link và đặt món liền mạch, không thoát app giữa chừng hoặc bấm vào link SPF của đối tác khác.',
        'Bấm Đặt món ngay hoặc Chia sẻ nhận thưởng đều được hoàn tiền (bao gồm cả việc thêm giỏ canh mã, áp xu…).',
        'Mua 1 quán nhiều món, chỉ cần copy link quán -> dán hoàn tiền -> mở ShopeeFood rồi thêm giỏ mua hàng.',
    ],
    expandedReject: [COMMON_EXPANDED_REJECT_FIRST],
    fraudList: FRAUD_LIST,
    closingNote: CLOSING_NOTE,
};
